import './DetailLink.css';

export interface DetailLinkProps {
  /** The URL to navigate to */
  href: string;
  /** Optional tooltip text */
  title?: string;
  /** Click handler — use for SPA navigation (e.g. react-router navigate) */
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

/** Small arrow icon that links to a detail page. Place inline next to headings or labels. */
export function DetailLink({ href, title, onClick }: DetailLinkProps) {
  return (
    <a
      href={href}
      className="sui-detail-link"
      title={title || 'View details'}
      onClick={onClick}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 17L17 7" />
        <path d="M7 7h10v10" />
      </svg>
    </a>
  );
}
